const translations = {
    addCertification: 'Add certification',
    addCertificationLabel: 'Add certification for {{memberName}}',
    expiredTooltip: '{{certificationNumber}} · Expired {{expirationDate}}',
    expiresInDayTooltip: '{{certificationNumber}} · Expires in 1 day',
    expiresInDaysTooltip: '{{certificationNumber}} · Expires in {{dayCount}} days',
    expiresTodayTooltip: '{{certificationNumber}} · Expires today',
    hiddenCertificationsTooltip: 'Also certified in {{states}}',
    noExpirationTooltip: '{{certificationNumber}} · No expiration date',
    validThroughTooltip: '{{certificationNumber}} · Valid through {{expirationDate}}'
};

export default translations;
